


























import { Component, Vue } from "vue-property-decorator";
import {
  RimRepairLayoutComponent,
} from "@/components/common";
import { ICustomer, Callback, ICustomerAddress } from "@/interfaces";
import { makeCustomer } from "@/utils";
import { InsertCustomer, GetCustomer, UpdatedCustomer } from "@/api";
import { Action } from "vuex-class";
import CustomerTabs from './customer-tabs.vue'
import { UserInterface } from '@/utils/UserInterface';

@Component({
  components: {
    RimRepairLayoutComponent,
		CustomerTabs
  },
})
export default class CustomerFormComponent extends Vue {
  public customer: ICustomer = makeCustomer({});
	
  // public buttonLoading = false;
	public id: number | null = null;

	private UI__: UserInterface;
	
  // @Action("setSnackbar", { namespace: "AppModule" })
  // public setSnackbarAction!: Callback;

  // public req = REQUIRED_RULE;

  async mounted() {
		this.UI__ = new UserInterface(this);
    this.id = +this.$route.params.id || null;
    if (this.id) {
      this.getCustomer();
    }
  }

  async getCustomer() {
    if (this.id) {
      // this.buttonLoading = true;

			this.UI__.TurnBlockerOn();
      const resp = await GetCustomer(this.id);
			this.UI__.TurnBlockerOff();
			
      if (resp.Ok) {
        this.customer = resp.Customer;
      }
      // this.buttonLoading = false;
    }
  }

  get title() {
    return this.id ? "Edit Customer" : "New customer";
  }

  get buttonLabel() {
    return this.id ? "Update Customer" : "Add";
  }

  // copy(from: string) {
  //   if (from === "Billing")
  //     this.customer.Billing = { ...this.customer.Shipping };
  //   if (from === "Shipping")
  //     this.customer.Shipping = { ...this.customer.Billing };
  // }

  async validate() {
		var isValid: boolean = (this.$refs.form as HTMLFormElement).validate();
		

    if (isValid) {
      // this.buttonLoading = true;
      let resp;

			this.UI__.TurnBlockerOn();
        resp = this.id
          ? await UpdatedCustomer(this.customer)
          : await InsertCustomer(this.customer);
       this.UI__.TurnBlockerOff();

			  // this.buttonLoading = false;
				if (resp.Ok) 
				{
					this.UI__.SnacSuccess(`Customer ${this.id ? "edited" : "added"} successfully`);

          if (this.id) {
            /// IT WAS AN UPDATE, REMAIN HERE.
          } else {
            /* IT WAS AN INSERT, RETURN TO
             */
            this.$router.push("/office/customers");
          }

						/// SENDING A NOTIFICATION, SO COMPONENTS
						/// WITH CUSTOMERS REFRESH THEIR DATA.
						/// 
						this.UI__.RefreshTimestampCustomers();


        }else{
			this.UI__.SnacError(resp.Msg);
					
				}
    } else {
			this.UI__.SnacError(`Fix Validation Errors`);
    }
  }

  // public CopyFromBilling(): void {
	// 	this.Copy(this.customer.Billing, this.customer.Shipping);
  // }

  // public CopyFromShipping(): void {
	// 	this.Copy(this.customer.Shipping, this.customer.Billing);
	// }
	
	// private Copy(s:ICustomerAddress, t:ICustomerAddress){
	// 	t.FName = s.FName;
	// 	t.LName = s.LName;
	// 	t.Email = s.Email;
	// 	t.Phone = s.Phone;
	// 	t.Mobile = s.Mobile;
	// 	t.Address = s.Address;
	// 	t.Address2 = s.Address2;
	// 	t.City = s.City;
	// 	t.State = s.State;
	// 	t.Zip = s.Zip;
	// }

}
